import mixitup from 'mixitup';
const mixitupMultifilter = require('../mixitup-multifilter.min.js');
mixitup.use(mixitupMultifilter);

class MixitupFilter {
    constructor(wrapper) {
        this.filterButtons = wrapper.querySelectorAll('.filter-button');
        this.mixContainer = wrapper.querySelector('.portfolio-mixer');
        this.panel = wrapper.querySelector('.panel-body');
        this.elms = wrapper.querySelectorAll('[data-checkbox]');
        this.resetButtons = wrapper.querySelectorAll('.label--button');

        this.filteredTags = [];

        this.noItemsFoundMessage = document.getElementById('noItemsFoundMessage');
        noItemsFoundMessage.style.display = 'none';

        if(this.mixContainer) {
            let mixer = mixitup('.portfolio-mixer', {
                animation: {
                    animateResizeContainer: false,
                    effects: 'fade scale'
                },
                multifilter: {
                    enable: true,
                },
                callbacks: {
                    onMixEnd: function(state){
                        if(state.hasFailed) {
                           noItemsFoundMessage.style.display = 'block';
                        }
                        else {
                           noItemsFoundMessage.style.display = 'none';
                        }
                    }
                }
            });
        }

        this.elms.forEach(el => {
            const button = el.parentNode.querySelector('.label--button');
            el.addEventListener('click', e => {
                this.checkFilters();
                button.classList.remove('active');
            })
        })

        this.resetButtons.forEach(button => {
            button.addEventListener('click', e => {
                button.classList.add('active');
            })
        })
    }

    checkFilters() {
        this.filteredTags = [];

        const checkedInputs = this.panel.querySelectorAll('input:checked');

        if (checkedInputs.length) {
            checkedInputs.forEach(input => {
                this.filteredTags.push(input.getAttribute('id'));
            });
            document.body.classList.add('projects--filtered');
        } else {
            document.body.classList.remove('projects--filtered');
        }
    }
}

export default class Filter {
	static init(){
		document.addEventListener('bless', () => {
            const filterWrapper = document.querySelectorAll('.mixitup-wrapper');

            if (!filterWrapper) {
                return;
            }

            filterWrapper.forEach(filter => {
                new MixitupFilter(filter);
            });
		});
	}
}
